import { useEffect, useState } from "react";
import Dashboard from "../dashboard/Dashboard";
import Card from "../../components/cards/Card";
import { NavLink } from "react-router-dom";
import { TeacherStatus } from "../../services/teacher.service";
import { getTotalTeachersByStatus } from "../../services/teacher.service";
import "./teachers.scss";
import showToast from "../../utils/show.toast";

export default function Teachers() {
  const [isLoadingTeachersCount, setIsLoadingTeachersCount] =
    useState<boolean>(false);
  const [teachersCount, setTeachersCount] =
    useState<Record<TeacherStatus, number>>();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoadingTeachersCount(true);
      try {
        const teachersCountResult = await getTotalTeachersByStatus();
        setTeachersCount(teachersCountResult);
      } catch (error) {
        return showToast("Error fetching stats!", false);
      } finally {
        setIsLoadingTeachersCount(false);
      }
    };
    fetchData();
  }, []);

  return (
    <Dashboard pageTitle="Teachers">
      <section className="card-container">
        <NavLink to={`/teachers/list?status=${TeacherStatus.REGISTERED}`}>
          <Card
            title="Unreviewed"
            description="Total number of teachers registered in the system."
            isLoading={isLoadingTeachersCount}
            number={teachersCount?.registered ?? 0}
          />
        </NavLink>

        <NavLink to={`/teachers/list?status=${TeacherStatus.ACCEPTED}`}>
          <Card
            title="Approved"
            description="Total number of teachers registered in the system."
            number={teachersCount?.accepted ?? 0}
          />
        </NavLink>

        <NavLink to={`/teachers/list?status=${TeacherStatus.VERIFIED}`}>
          <Card
            title="Verified"
            description="Total number of teachers registered in the system."
            number={teachersCount?.verified ?? 0}
          />
        </NavLink>

        <NavLink to={`/teachers/list?status=${TeacherStatus.SUSPENDED}`}>
          <Card
            title="Suspended"
            description="Total number of teachers suspended."
            number={teachersCount?.suspended ?? 0}
          />
        </NavLink>
      </section>
    </Dashboard>
  );
}
